import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `Application/Subjects/**`. */
const SubjectsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification eventName="SUBJECT_CREATED" title="Succès" message="Dossier créé." />
			<ErrorNotification
				eventName="SUBJECT_CREATION_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être créé."
			/>
			<ErrorNotification
				eventName="SUBJECTS_FETCH_FAILED"
				title="Erreur"
				message="La liste des dossiers n'a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="SUBJECT_FETCH_FAILED"
				title="Erreur"
				message="Le dossier n'a pas pu être chargé."
			/>
			<SuccessNotification eventName="SUBJECT_UPDATED" title="Succès" message="Fiche enregistrée." />
			<ErrorNotification
				eventName="SUBJECT_UPDATE_FAILED"
				title="Erreur"
				message="La fiche n'a pas pu être enregistrée."
			/>
			<SuccessNotification eventName="SUBJECT_ARCHIVED" title="Succès" message="Dossier archivé." />
			<SuccessNotification eventName="SUBJECT_RESTORED" title="Succès" message="Dossier désarchivé." />
			<ErrorNotification
				eventName="SUBJECT_ARCHIVAL_CHANGE_FAILED"
				title="Erreur"
				message="L'archivage du dossier n'a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="ABOUT_CANDIDATES_FETCH_FAILED"
				title="Erreur"
				message="La recherche n'a pas pu aboutir."
			/>
			<SuccessNotification
				eventName="SUBJECT_MEMBER_SAVED"
				title="Succès"
				message="Membre enregistré."
			/>
			<SuccessNotification eventName="SUBJECT_MEMBER_REMOVED" title="Succès" message="Membre retiré." />
			<ErrorNotification
				eventName="SUBJECT_MEMBER_SAVE_FAILED"
				title="Erreur"
				message="Le membre n'a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="SUBJECT_MEMBER_REMOVAL_FAILED"
				title="Erreur"
				message="Le membre n'a pas pu être retiré."
			/>
			<ErrorNotification
				eventName="SUBJECT_MEMBERS_FETCH_FAILED"
				title="Erreur"
				message="La liste des membres n'a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="SUBJECT_USERS_FETCH_FAILED"
				title="Erreur"
				message="La liste des personnes de l'agence n'a pas pu être chargée."
			/>
		</React.Fragment>
	);
};

export default SubjectsNotifications;
